<p class="text-center no-data">
  <em
    id="no-data-warning"
    class="fa fa-exclamation-triangle fa-3x"
    aria-hidden="true "
  ></em>
  <br />
  <br />
  <span>{{
    infoText | translate
  }}</span>
</p>
